import { FC, MouseEventHandler, useEffect, useState } from 'react';
import { useFormContext } from '../../../../contexts/FormContext';
import { FormType } from '../../../../types/FormTypes';
import { BasicButton } from '../../../shared/buttons/BasicButton';

import styles from './GenerateResponseButtons.module.css';

type GenerateResponseButtonsProps = {
  onSubmit: MouseEventHandler<HTMLButtonElement>;
};

export const GenerateResponseButtons: FC<GenerateResponseButtonsProps> = ({
  onSubmit,
}) => {
  const { formType, loading } = useFormContext();

  const [generateButtonText, setGenerateButtonText] =
    useState<string>('Generate Draft');

  useEffect(() => {
    let newGenerateButtontext = generateButtonText;
    switch (formType) {
      case FormType.MARKETINGIDEAS:
      case FormType.PERSONAMARKETINGIDEAS:
      case FormType.HERO_HEADER:
      case FormType.PERSONA_HERO_HEADER:
      case FormType.SUBHEADER:
      case FormType.PERSONA_SUBHEADER:
      case FormType.FEATURE_DESCRIPTION:
      case FormType.PERSONA_FEATURE_DESCRIPTION:
      case FormType.PERSONA_CALL_TO_ACTION:
      case FormType.CALL_TO_ACTION:
      case FormType.BLOG:
        newGenerateButtontext = loading
          ? 'Brainstorming'
          : 'Generate Brainstorm';
        break;
      case FormType.CONTENT_IMPROVER:
        newGenerateButtontext = loading ? 'Improving' : 'Improve Copy';
        break;
      case FormType.AUDIENCE_RETARGET:
        newGenerateButtontext = loading ? 'Retargeting' : 'Retarget Copy';
        break;
      default:
        newGenerateButtontext = loading ? 'Generating' : 'Generate Draft';
    }
    setGenerateButtonText(newGenerateButtontext);
  }, [formType, loading]);

  return (
    <div className={styles['buttons-container']}>
      <BasicButton
        theme="red-orange"
        type="submit"
        loading={loading}
        disabled={loading}
        onClick={onSubmit}
        text={generateButtonText}
        image={{
          src: '/icons/PlaylistBlack.svg',
          height: 16,
          width: 16,
        }}
      />
      <BasicButton
        type="submit"
        disabled={loading}
        onClick={onSubmit}
        text="Refresh"
        image={{
          src: '/icons/Refresh.svg',
          height: 16,
          width: 16,
        }}
        tooltip="regenerate"
      />
    </div>
  );
};
